<template>
  <div id="documents-content" class="main-content">
    <the-header :title="t('Documents')" />
      <data-grid :settings="grid"
                 ref="dataGrid"
                 :storeDispatchList="listData"
                 :page="parseInt($route.params.page)"
                 v-on:changePage="$router.push({name: 'dataExports', params: {page: $event}})"

      >
        <template slot="exportButton" slot-scope="data">
<!--          <b-button variant="primary" target="_blank" :href="data.item.link"><font-awesome-icon icon="file-download"/>   {{t('Download')}}</b-button>-->
          <a target="_blank" :href="data.item.documentLink">{{t('Show')}}</a>
        </template>
      </data-grid>
  </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader';
    import NavBody from '../../../admin/Layout/NavBody';
    import StaticText from '../../../admin/Pages/StaticText/StaticText';
    import DataGrid from '../../../core/DataGrid/DataGrid';

    export default {
        components: {
            StaticText,
            TheHeader,
            NavBody,
            DataGrid
        },
        created() {
        },
        methods: {
            listData(params) {
                params.page = 1;
                return this.$store.dispatch('documents/list',params)
            }
        },
        data() {
            return {
                grid: {
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Name'),
                            key: 'name'
                        }, {
                            type: 'date',
                            name: this.t('Date published'),
                            key: 'datePublished'
                        }, {
                            type: 'string',
                            name: this.t('Show'),
                            key: 'exportButton'
                        }
                    ]
                }
            }
        }
    }

</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/private/documents/documents.vue